<template>
  <div class="grid-parts__wrap-inner-tools">
    <grid v-show="aircraftID" ref="grid" :config="gridConfig" class="no-grid-border">
      <template v-slot:inner-tools>
        <grid-tool-controls
          :controls="gridControls"
          class="inner-tool-controls"
          @command="handleCommand"
        />
      </template>
    </grid>
    <editor
      :config="{id: gridConfig.id, api: 'Fleets/Get/'}"
      :aircraftID="aircraftID"
      :editorID="editorID"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.json'
import models from '@/components/Grid/models.js'
import { waitValue } from '@/utils/promises'

export default {
  name: 'Fleets',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Parts' */ './Editor'),
    'grid-tool-controls': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/GridToolControls')
  },
  props: {
    aircraftID: { required: true },
    editorID: { required: true }
  },
  watch: {
    aircraftID: {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.aircraftID) {
              grid.model.store.get.filters = `aircraftID == ${this.aircraftID}`
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    gridControls () {
      return this.$_.merge(models.grid(this.$root).header.controls, {
        isRefresh: true,
        export: {
          json: {
            current: {
              isVisible: false
            },
            all: {
              isVisible: false
            }
          }
        },
        addNew: {
          isVisible: false
        }
      })
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    handleCommand () {
      this.getGrid()
        .then((grid) => {
          grid.handleCommand(...arguments)
        })
    }
  }
}
</script>
